var exports = {
  "zr": "x93eb46d8--bb3b92--root",
  "jW": "x93eb46d8--bb3b92--photo",
  "Yy": "x93eb46d8--bb3b92--photo--compact",
  "Qs": "x93eb46d8--bb3b92--content",
};

module.exports = exports;
